import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const ClassesPage = lazy(() =>
  import('./pages/ClassesPage').then(m => ({ default: m.ClassesPage }))
);
const ClassDetailPage = lazy(() =>
  import('./pages/ClassDetailPage').then(m => ({ default: m.ClassDetailPage }))
);
const JoinClassPage = lazy(() =>
  import('./pages/JoinClassPage').then(m => ({ default: m.JoinClassPage }))
);

/** In-shell class pages. Parents have no class surface yet (backend returns
 *  none for them) — the role gate mirrors that. */
export const classRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher', 'pupil']} />}>
    <Route path="/classes" element={<ClassesPage />} />
    <Route path="/classes/:publicId" element={<ClassDetailPage />} />
  </Route>
);

/** Full-page join-by-code flow — mounted inside <RequireAuth> but OUTSIDE
 *  <RequireSchool>: a fresh account with zero memberships joins here (the
 *  code resolves the school; no X-School header needed). */
export const joinClassRoutes = <Route path="/join" element={<JoinClassPage />} />;
